import React from "react";
import OrganizationInlineEditInput from "./OrganizationInlineEditInput";
import InlineEditValidatedInputWysiwyg from "../../common/widgets/InlineEditValidatedInputWysiwyg";

/**
 * Generic component for all organization editable wysiwyg fields
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function OrganizationInlineEditInputWysiwyg(props) {
  return <OrganizationInlineEditInput InlineEditInputComponent={InlineEditValidatedInputWysiwyg} {...props}/>
};
